import { Site, SiteContext } from './../../../../../api';
import { freezeDeep } from './../../../../../utils';

export const EMPTY_SITE: Site = freezeDeep({
    pages: [],
    id: '00000000-0000-0000-0000-000000000000'
});

export const EMPTY_SITE_CONTEXT: SiteContext = freezeDeep({
    parent: undefined,
    sibling: [],
    breadcrumb: [],
    children: [],
    site: EMPTY_SITE
});
